export const scrollModalToTop = () => {
  const modalElement = document.getElementsByClassName(
    'ReactModal__Content'
  )[0];
  if (modalElement) {
    modalElement.scrollTop = 0;
  }
};
